<template>
    <SrList class="pa-0">
        <SrListItemGroup
            v-bind="$attrs"
            v-model="activeIndex"
            :mandatory="mandatory"
            active-class="sr-navigation-bar-item--active"
        >
            <div
                v-for="(item, index) in items"
                :key="index"
                v-can="{
                    actionName: item.actionName || 'read',
                    domainName: item.domainName,
                    resourceType: item.resourceType,
                }"
                :disabled="item.disabled"
            >
                <SrNavigationBarItem :item="item" :disabled="item.disabled" />
            </div>
        </SrListItemGroup>
    </SrList>
</template>

<script>
import SrNavigationBarItem from './SrNavigationBarItem';
import SrList from '../SrList/SrList';
import SrListItemGroup from '../SrListItemGroup/SrListItemGroup';

export default {
    name: 'SrNavigationBar',
    components: { SrNavigationBarItem, SrListItemGroup, SrList },
    props: {
        items: {
            type: Array,
            required: true,
            validator: (items) => !items.some((item) => !item.title),
        },
        mandatory: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    data() {
        return {
            activeIndex: 0,
        };
    },
    watch: {
        items: {
            handler() {
                this.initActiveItemFromRoute();
            },
            deep: true,
        },
        $route() {
            this.initActiveItemFromRoute();
        },
    },
    mounted() {
        this.initActiveItemFromRoute();
    },
    methods: {
        initActiveItemFromRoute() {
            if (!this.$route) {
                return;
            }

            for (let index = 0; index < this.items.length; index++) {
                const item = this.items[index];
                if (this.$route?.matched.some((route) => route.name === item.routeName && !item.disabled)) {
                    this.activeIndex = index;
                    return;
                }
            }
        },
    },
};
</script>
